module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_8004.13155cb7.png";